import React, {useEffect, useState} from 'react';
import {
    Box, Button, Grid, Typography
} from "@mui/material";
import {Link, Navigate, Outlet, useLocation, useNavigate, useOutlet, useOutletContext} from "react-router-dom";
import {useTranslation} from "react-i18next";
import Swal from 'sweetalert2'
import LocationItem from "./LocationItem";

export default function LocationIndex(props) {
    const token = localStorage.getItem('accessToken');
    const {t} = useTranslation('common');
    const [apiUri] = useOutletContext();
    const [loaded, setLoaded] = useState(false);
    const [locationList, setLocationList] = useState([]);
    const outlet = useOutlet()
    const navigate = useNavigate();

    useEffect(() => {
        props.setLabel('location.title');
        locationIndexGet();
    }, [])

    if (token == null) {
        return ( //
            <Navigate to='/login'/>
        );
    }

    async function locationIndexGet() {
        return fetch(apiUri + 'location_index', {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
                'Accept': 'application/json'
            }
        })
            .then(data => data.json())
            .then(data => {
                if (data.state == 'OK') {
                    setLoaded(true);
                    setLocationList(data.locations);
                } else {
                    Swal.fire({
                        text: t(data.message),
                        icon: 'error',
                        customClass: {
                            container: 'my-swal'
                        }
                    });
                }
            })
    }

    function locationUpdatedHandler() {
        navigate("/location");
        locationIndexGet();
    }

    return (
        <>
            {/*<Typography variant="h4">*/}
            {/*    {t("location.title")}*/}
            {/*</Typography>*/}
            <Grid justifyContent="center" container>
                <Link to="/location/add" style={{textDecoration: 'none'}}>
                    <Button
                        variant="contained"
                        color="yellow"
                        sx={{mt: '15px', mb: '20px'}}
                    >
                        {t('location.button_create_location')}
                    </Button>
                </Link>
            </Grid>
            <Box width="100%" sx={{mt: 1}}/>
            {loaded &&
            <>
                {locationList.length == 0 ?
                    <>
                        <h3>
                            {t("location.empty_list_message")}
                        </h3>
                    </>
                    :
                    <>
                        {
                            locationList.map((location, i) => {
                                return (<LocationItem key={i} locationData={location}/>);
                            })
                        }
                    </>
                }

                <Grid justifyContent="center" container>
                    <Link to="/location/add" style={{textDecoration: 'none'}}>
                        <Button
                            variant="contained"
                            color="yellow"
                            sx={{mt: '15px', mb: '20px'}}
                        >
                            {t('location.button_create_location')}
                        </Button>
                    </Link>
                </Grid>

                <Outlet context={[apiUri, locationUpdatedHandler]}/>
            </>
            }
        </>
    );
}